module.exports = __webpack_public_path__ + "img/icon-barcode.7c0c68b2.svg";